import { Device } from '@bcf-shared-settings/settings/types';
import { deviceBase } from 'configs/device/casino/mobile/device.base';

export const device: Device = {
  ...deviceBase
};
